import { findParentRef } from "../utils/util";
import FileSaver from "file-saver";

export default {
  methods: {
    async downloadDataExport(containerRef, storeCommand, fileName, id) {
      let loading = this.$buefy.loading.open({
        container: findParentRef(this, containerRef).$el,
      });

      try {
        let blob = await this.$store.dispatch(storeCommand, id);
        FileSaver.saveAs(blob, fileName);
      } finally {
        loading.close();
      }
    },
    async downloadListExport(
      containerRef,
      storeCommand,
      datatableRef,
      fileName
    ) {
      let loading = this.$buefy.loading.open({
        container: findParentRef(this, containerRef).$el,
      });

      let tableQuery;
      try {
        tableQuery = findParentRef(this, datatableRef).getQuery();
      } catch (ex) {
        tableQuery = "page=0";
      }

      try {
        let blob = await this.$store.dispatch(storeCommand, tableQuery);
        FileSaver.saveAs(blob, fileName);
      } finally {
        loading.close();
      }
    },
  },
};
